import { render } from "./RegisterFacebookPageEntry.vue?vue&type=template&id=61cfbe70"
import script from "./RegisterFacebookPageEntry.vue?vue&type=script&lang=js"
export * from "./RegisterFacebookPageEntry.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__